import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Toast } from 'antd-mobile';
import styles from './styles.module.less';
import { getImAppId, getImOpenId, getUserRank } from '../../service/chat-service';
import tools from '../../utils/tools';
import rankingheader from '../../public/images/rankingheader.png';
import rankings from '../../public/images/rankings.png';
import no1 from '../../public/images/no1.png';
import no2 from '../../public/images/no2.png';
import no3 from '../../public/images/no3.png';

const propTypes = {
  location: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
const defaultProps = {};

// 排行榜页
class sharelist extends Component {
  constructor(props) {
    super(props);
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const id = new URLSearchParams(windowHref).get('id');
    this.state = {
      id,
      dataList: [],
      userInfo: '',
      userRank: '',
    };
  }

  componentDidMount() {
    document.title = '邀请排行榜';
    this.getLiveOpenId(); // 微信授权上线前打开
    // this.getUserRankLiveInfo(); // 本地测试上线前关闭
  }

  /**
   * 微信授权
   * @returns {Promise<void>}
   */
  getLiveOpenId = async () => {
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const WXCode = queryString.parse(windowHref).code;
    if (!WXCode) {
      localStorage.clear();
      try {
        const { code, data, message } = await getImAppId();
        if (process.env.REACT_APP_API_ENV === 'local') {
          // 本地测试时不走微信验证
          this.getUserRankLiveInfo('oQd0LwJcSPgP7eYwSy38bUdb793A');
        } else if (code === 10000) {
          window.location.href = tools.toWxth(data);
        } else {
          Toast.show(message || '获取微信 appId 失败');
        }
      } catch (e) {
        Toast.show('获取微信 appId 失败');
      }
    } else if (!localStorage.getItem('openId')) {
      try {
        const { code, data } = await getImOpenId(WXCode);
        if (code === 10000) {
          localStorage.setItem('openId', data.openid);
          this.getUserRankLiveInfo(data.openid);
          this.shareQrCodes(data.openid);
        }
      } catch (e) {
        Toast.show(e);
      }
    } else {
      this.getUserRankLiveInfo(localStorage.getItem('openId'));
      this.shareQrCodes(localStorage.getItem('openId'));
    }
  }

  /**
   * 获取详情
   * @param openId
   * @param getType
   */
  getUserRankLiveInfo = async (openId) => {
    const { id } = this.state;
    const ids = +id;
    // 本地联调 openId:"11111",
    const params = {
      openId,
      id: ids,
      pageNum: 1,
      pageSize: 100,
    };
    try {
      const { data } = await getUserRank(params);
      this.setState({
        dataList: data.pageList,
        userInfo: data.userInfo,
        userRank: data.userRank,
      });
    } catch (e) {
      Toast.show('获取详情失败');
    }
  }

  rankingList = () => {
    const { dataList } = this.state;
    return dataList.map((item, k) => (
      <div className={styles.p_footerlist} key={item.id}>
        <div className={styles.p_content_left}>
          <div>{item.userName}</div>
          <div>
            已要邀请
            {item.signUpUser}
            位好友参与~
          </div>
        </div>
        <div style={{ width: '20%' }}>
          {this.numbers(k + 1)}
        </div>
      </div>
    ));
  }

  numbers=(k) => {
    switch (k) {
      case 1:
        return <img src={no1} alt="" />;
      case 2:
        return <img src={no2} alt="" />;
      case 3:
        return <img src={no3} alt="" />;
      default:
        return <span>{k}</span>;
    }
  }

  render() {
    const { userInfo, userRank } = this.state;
    return (
      <div className={styles.body} style={{ padding: 0 }}>
        <div className={styles.p_header}>
          <img src={rankingheader} alt="" />
        </div>
        <div className={styles.p_content}>
          <div style={{ display: 'flex' }}>
            <div className={styles.p_content_left}>
              <div>{userInfo.userName}</div>
              <div>
                您已要邀请
                {userInfo.signUpUser}
                位好友参与~
              </div>
            </div>
            <div className={styles.p_content_right}>
              <div>
                <img src={rankings} alt="" />
              </div>
              <div>
                <span>排名:</span>
                <span>
                  {userRank}
                  <span>位</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.p_footer}>
          <div className={styles.p_footerover}>
            <div className={styles.p_footerHeader}>
              <span style={{ flex: 1 }}>姓名</span>
              <span style={{ width: '20%' }}>排名</span>
            </div>
            {this.rankingList()}
          </div>
        </div>
      </div>
    );
  }
}

sharelist.propTypes = propTypes;
sharelist.defaultProps = defaultProps;

export default sharelist;
